import { Component, ChangeDetectionStrategy, Input } from '@angular/core';

@Component({
    selector: 'shared-open-hours',
    templateUrl: './open-hours.shared.component.html',
    styleUrls: ['./open-hours.shared.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OpenHoursComponent {
    @Input() public currenWeekDay: number = new Date().getDay();

    @Input() public openHours: APICommon.LocationOrderingTimeInfoExtendedModel[] = [];

    public trackBy(index: number, obj: APICommon.LocationOrderingTimeInfoExtendedModel): number {
        return index;
    }
}
